<template>
<div>
    <p class="text-muted small">Medical Certificate for Teacher's Sick Leave.</p>

    <b-form @submit.prevent="onSubmit" novalidate>
        <b-row>
            <b-col md="6">
                <b-form-group label="Patient name"><b-form-input v-model="form.name" /></b-form-group>
                <b-form-group label="Examined on"><b-form-datepicker v-model="form.exam_date" /></b-form-group>
                <b-form-group label="Suffering from"><b-form-textarea rows="2" v-model="form.diagnosis" /></b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group label="Unable to perform duties for (period)"><b-form-input v-model="form.unable_period" placeholder="e.g. 7 days" /></b-form-group>
                <b-form-group label="Doctor signature label"><b-form-input v-model="form.signed_by" /></b-form-group>
                <b-form-group label="Status (e.g. GP, Specialist)"><b-form-input v-model="form.status" /></b-form-group>
            </b-col>
        </b-row>

        <div class="text-right mt-3">
            <b-button variant="secondary" @click="$emit('close')">Cancel</b-button>
            <b-button type="submit" variant="success">
                <i class="fa-solid fa-file-arrow-down"></i> Generate PDF
            </b-button>
        </div>
    </b-form>
</div>
</template>

<script>
import { formatDate, fullName, loadCoords } from "./pdfFiller"
import formPersistence from "./formPersistence"

export default {
    name: "teacher-sick-leave-form",
    mixins: [formPersistence],
    props: { demographics: { type: Object, default: () => ({}) } },
    data() {
        return {
            form: {
                name: "",
                exam_date: new Date().toISOString().slice(0, 10),
                diagnosis: "",
                unable_period: "",
                signed_by: "",
                status: "",
            },
        }
    },
    watch: {
        demographics: {
            immediate: true,
            handler(d) {
                if (!d) return
                if (!this.form.name) this.form.name = fullName(d)
            },
        },
    },
    methods: {
        buildCoords() {
            // Approximate coords for teacher-sick-leave.pdf (single page,
            // two certificates stacked).
            return {
                name: { page: 0, x: 180, y: 700 },
                exam_date: { page: 0, x: 105, y: 678 },
                diagnosis: { page: 0, x: 175, y: 654 },
                unable_period: { page: 0, x: 270, y: 632 },
                signed_by: { page: 0, x: 220, y: 558 },
                status: { page: 0, x: 220, y: 538 },
            }
        },
        buildValues() {
            const f = this.form
            return {
                name: f.name,
                exam_date: formatDate(f.exam_date),
                diagnosis: f.diagnosis,
                unable_period: f.unable_period,
                signed_by: f.signed_by,
                status: f.status,

                // Bottom (duplicate) certificate — same values
                name_2: f.name,
                exam_date_2: formatDate(f.exam_date),
                diagnosis_2: f.diagnosis,
                unable_period_2: f.unable_period,
                signed_by_2: f.signed_by,
                status_2: f.status,
            }
        },
        async onSubmit() {
            try {
                const coords = (await loadCoords("teacher-sick-leave")) || this.buildCoords()
                await this.fillAndPersist({ form_key: "teacher-sick-leave", title: "Teacher's Sick Leave" }, {
                    templateUrl: "/forms/teacher-sick-leave.pdf",
                    outputName: `teacher-sick-leave-${this.form.name || "patient"}.pdf`,
                    values: this.buildValues(),
                    coords,
                })
                this.$emit("close")
            } catch (e) {
                this.$bvToast.toast(e.message || "Could not generate PDF", {
                    title: "PDF generation failed",
                    variant: "danger",
                })
            }
        },
    },
}
</script>
